import React from "react";
import "./studio.scss";

import f1 from "../../assets/studio/f1.webp";
import s1 from "../../assets/studio/s1.webp";
import s2 from "../../assets/studio/s2.webp";
import s3 from "../../assets/studio/s3.webp";
import s4 from "../../assets/studio/s4.webp";
import s5 from "../../assets/studio/s5.webp";
import SectionHeader from "../section_header/SectionHeader";
import { GoDotFill } from "react-icons/go";
import { PhotoProvider, PhotoView } from "react-photo-view";

const Studio = () => {
  const images = [s1, s2, s3, s4, s5];

  return (
    <div className="studio_main">
      <div className="studio_header">
        <SectionHeader name={"OUR STUDIO"} />
      </div>
      <div className="studio_container">
        <div className="stuido_founder">
          <div className="founder_img_name">
            <h2>
              Ar. Irfan H.S
              <br />
              <span style={{ letterSpacing: "1px" }}>
                FOUNDER <GoDotFill />
                RENDERX ARCHITECTS
              </span>
            </h2>
            <img src={f1} alt="RenderX Architects Founder" />
          </div>
        </div>
        <div className="writeup_studio_imgs">
          <p>
            - I firmly believe that every space must be meticulously designed to
            achieve its highest functional and experiential potential. As an
            architect, I consider it a privilege to create such environments.
          </p>
          <div className="studio_images">
            <PhotoProvider
              maskOpacity={0.9}
              speed={() => 500}
              loop={false}
              easing={(type) =>
                type === 2 ? "cubic-bezier(0.16, 1, 0.3, 1)" : "ease"
              }
            >
              <PhotoView src={s1}>
                <img src={s1} alt="Studio_img1" />
              </PhotoView>
              <PhotoView src={s2}>
                <img src={s2} alt="Studio_img2" />
              </PhotoView>

              <PhotoView src={s4}>
                <img src={s4} alt="Studio_img4" />
              </PhotoView>
              <PhotoView src={s5}>
                <img src={s5} alt="Studio_img5" />
              </PhotoView>
            </PhotoProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Studio;
